import React from "react";
import { CloseButtonProps } from "react-toastify";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

const Default = {
  CSS_NAMESPACE: "Toastify",
};

export function ToastifyCloseButton({
  closeToast,
  theme,
  ariaLabel = "close",
  type,
}: CloseButtonProps) {
  return (
    <TestWrapper testId={`toast-close-button__${type}`}>
      <button
        className={`${Default.CSS_NAMESPACE}__close-button ${Default.CSS_NAMESPACE}__close-button--${type} ${Default.CSS_NAMESPACE}__close-button--${theme}`}
        type="button"
        onClick={e => {
          e.stopPropagation();
          closeToast(true);
        }}
        aria-label={ariaLabel}
      >
        <svg aria-hidden="true" viewBox="0 0 14 16">
          <path
            fillRule="evenodd"
            d="M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
          />
        </svg>
      </button>
    </TestWrapper>
  );
}
